import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ObrasHistoricoService } from 'src/app/services/obras-historico.service';
import { ObrasHistoricoDto } from 'src/app/models/dtos/obras-historico-dto';

@Component({
  selector: 'modal-ficha-tecnica-historico',
  templateUrl: './modal-ficha-tecnica-historico.component.html',
  styleUrls: ['./modal-ficha-tecnica-historico.component.scss']
})
export class ModalFichaTecnicaHistoricoComponent implements OnInit {

  @ViewChild('modalFichaTecnicaHistorico2')
  public modalFichaTecnicaHistorico2: any;

  public modalActivo: NgbModalRef;
  public obraSeleccionada: ObrasHistoricoDto;

  public informacionCargada: boolean = false;

  constructor(private modalService: NgbModal,
    private obraHistoricoService: ObrasHistoricoService) { }

  ngOnInit() {
  }

  public abrirModal() {
    this.obraHistoricoService.obtenerDatosObraHistorico().subscribe(
      (obra: ObrasHistoricoDto) => {
        this.obraSeleccionada = obra;
        this.informacionCargada = true;
      }
    );
    this.modalActivo = this.modalService.open(this.modalFichaTecnicaHistorico2, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

}
